// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.Industries = {
  industriesHash: null,
  error: null,
  industriesFetched: false,
};
